import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CONTACT_EMAIL } from '../constants';

@Component({
  selector: 'app-wind-offshore-modal',
  imports: [MatDialogModule],
  templateUrl: './wind-offshore-modal.html',
})
export class WindOffshoreModal {
  dialog = inject(MatDialog);

  contactEmail = CONTACT_EMAIL;

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
